import type { OnyxOptional } from '@onyx/angular';
import { isString } from 'lodash';
import { DateTime } from 'luxon';

export class DateTimeHelper {
  public static fromISO(timestamp: OnyxOptional<string>): DateTime | null {
    return timestamp ? DateTime.fromISO(timestamp) : null;
  }

  public static max(
    a: OnyxOptional<DateTime | string | 'now'>,
    b: OnyxOptional<DateTime | string | 'now'>,
  ): DateTime {
    const parseDate = (date: OnyxOptional<DateTime | string | 'now'>) => {
      if (date === 'now') return DateTime.now();
      return isString(date) ? DateTime.fromISO(date) : date;
    };

    const dateA = parseDate(a);
    const dateB = parseDate(b);

    if (!dateA && !dateB) return DateTime.now();
    if (!dateA) return dateB!;
    if (!dateB) return dateA;

    return dateA > dateB ? dateA : dateB;
  }
}
